<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
                        <a href="#">角色碎片取得一覽</a>
                    </router-link>
                </ol>
            </nav>
            <div class="item-box">
                <p>最後更新日: 2022/10/17</p>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">地下城兌換 Dungeon</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in Dungeon" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">競技場兌換 Arena</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in Arena" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">公主競技場兌換 PrincessArena</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in PrincessArena" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">戰隊賽兌換 Clan</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in Clan" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">困難模式掉落 Hard</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in Hard" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}<br />
                                    {{ item.map }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">女神石兌換 Divine Amulets</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in Megami" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">期間限定活動兌換 Limited Time Event</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in Event" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">支線故事兌換 SubStory</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in SubStory" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">支線故事列表 SubStory List</h3>
                    <div class="row">
                        <div class="col-12 col-lg-4 my-3" v-for="item in SubStoryList" v-if="item.eventItemList.length > 0">
                            <div class="piece-box w-auto">
                                <span class="d-block w-100 mb-3">{{ getI18nName(item, "event_name") }}</span>
                                <div class="d-block w-100 text-center">
                                    <div class="d-flex justify-content-center">
                                        <div v-for="pItem in item.eventItemList" class="mr-3">
                                            <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(pItem.unit_id) + '.png'" />
                                            {{ getUnitName(pItem) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">大師幣兌換 Master Coin</h3>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="pb-3 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                <div v-for="item in MasterCoin" class="piece-box mr-3 mb-3">
                                    <img width="80" v-lazy="'/static/images/item/icon_item_' + getItemName(item.unit_id) + '.png'" />
                                    {{ getUnitName(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pom-warp mb-3">
                    <h3 class="item-title">來源: gamewith 搬移</h3>
                    <a href="https://gamewith.jp/pricone-re/article/show/93166" target="_blank">https://gamewith.jp/pricone-re/article/show/93166</a>
                    <br />
                    <a href="https://gamewith.jp/pricone-re/article/show/191308" target="_blank"
                        >https://gamewith.jp/pricone-re/article/show/191308</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Stand",
    data() {
        return {
            Dungeon: [
                { unit_id: "100501" },
                { unit_id: "101501" },
                { unit_id: "102601" },
                { unit_id: "106001" },
                { unit_id: "103401" },
                { unit_id: "100601" },
                { unit_id: "104501" },
                { unit_id: "105101" },
                { unit_id: "101001" },
                { unit_id: "102901" },
                { unit_id: "105501" },
                { unit_id: "116201" },
            ],
            Arena: [
                { unit_id: "102301" },
                { unit_id: "100101" },
                { unit_id: "100401" },
                { unit_id: "104601" },
                { unit_id: "105301" },
                { unit_id: "101101" },
                { unit_id: "101301" },
            ],
            PrincessArena: [
                { unit_id: "100701" },
                { unit_id: "101701" },
                { unit_id: "100901" },
                { unit_id: "101201" },
                { unit_id: "101601" },
                { unit_id: "105401" },
                { unit_id: "115901" },
            ],
            Clan: [
                { unit_id: "104301" },
                { unit_id: "102201" },
                { unit_id: "101801" },
                { unit_id: "104201" },
                { unit_id: "102501" },
                { unit_id: "114501" },
            ],
            Hard: [
                {
                    unit_id: "105901",
                    map: "1-1/4-1/13-1/23-1/29-1/37-1/45-1",
                },
                {
                    unit_id: "102101",
                    map: "1-2/5-1/14-1/22-1/31-1/38-1/44-1",
                },
                {
                    unit_id: "104001",
                    map: "1-3/9-1/16-1/24-1/33-1/43-1/48-1/53-1",
                },
                {
                    unit_id: "100301",
                    map: "2-1/8-1/18-1/26-1/34-1/46-1/52-1",
                },
                {
                    unit_id: "100201",
                    map: "2-2/6-1/15-1/21-1/30-1/39-1/47-1/54-1",
                },
                {
                    unit_id: "102801",
                    map: "2-3/9-3/18-3",
                },
                {
                    unit_id: "105801",
                    map: "3-1/7-1/17-1/25-1/32-1/40-1/49-1/56-1",
                },
                {
                    unit_id: "105201",
                    map: "3-2/11-1/20-1/27-1/35-1/42-1/51-1",
                },
                {
                    unit_id: "102001",
                    map: "3-3/9-2/15-2/23-2/31-2/41-2/49-2/52-2",
                },
                {
                    unit_id: "105001",
                    map: "4-2/10-1/19-1/28-1/36-1/41-1/50-1",
                },
                {
                    unit_id: "103001",
                    map: "4-3/10-3/20-3/",
                },
                {
                    unit_id: "104801",
                    map: "5-2/10-2/16-2/22-2/29-2/36-2/45-2/50-2",
                },
                {
                    unit_id: "103801",
                    map: "5-3/12-2/18-2/25-2/32-2/42-2/48-2/56-2",
                },
                {
                    unit_id: "103301",
                    map: "6-2/12-1/19-2/26-2/33-2/38-2/43-2/51-2",
                },
                {
                    unit_id: "104901",
                    map: "6-3/11-3/23-3",
                },
                {
                    unit_id: "102701",
                    map: "7-2/11-2/17-2/24-2/30-2/37-2/47-2/55-2",
                },
                {
                    unit_id: "103101",
                    map: "7-3/14-2/21-2/27-2/34-2/39-2/44-2/53-2",
                },
                {
                    unit_id: "100801",
                    map: "8-2/13-2/20-2/28-2/35-2/40-2/46-2/54-2",
                },
                {
                    unit_id: "103201",
                    map: "8-3/12-3",
                },
                {
                    unit_id: "105701",
                    map: "13-3/19-3",
                },
                {
                    unit_id: "104701",
                    map: "14-3/22-3",
                },
                {
                    unit_id: "106301",
                    map: "15-3/30-3",
                },
                {
                    unit_id: "103601",
                    map: "16-3",
                },
                {
                    unit_id: "104401",
                    map: "17-3/31-3",
                },
                {
                    unit_id: "103701",
                    map: "21-3",
                },
                {
                    unit_id: "105601",
                    map: "24-3",
                },
                {
                    unit_id: "101401",
                    map: "25-3",
                },
                {
                    unit_id: "109201",
                    map: "26-3",
                },
                {
                    unit_id: "109401",
                    map: "27-3",
                },
                {
                    unit_id: "109501",
                    map: "28-3",
                },
                {
                    unit_id: "109601",
                    map: "29-3",
                },
                {
                    unit_id: "110701",
                    map: "32-3",
                },
                {
                    unit_id: "110801",
                    map: "33-3",
                },
                {
                    unit_id: "111301",
                    map: "34-3",
                },
                {
                    unit_id: "111401",
                    map: "35-3",
                },
                {
                    unit_id: "106501",
                    map: "36-3",
                },
                {
                    unit_id: "111701",
                    map: "37-3",
                },
                {
                    unit_id: "112201",
                    map: "38-3",
                },
                {
                    unit_id: "111001",
                    map: "39-3",
                },
                {
                    unit_id: "110901",
                    map: "40-3",
                },
                {
                    unit_id: "112701",
                    map: "41-3",
                },
                {
                    unit_id: "112801",
                    map: "42-3",
                },
                {
                    unit_id: "112901",
                    map: "43-3",
                },
                {
                    unit_id: "106601",
                    map: "44-3",
                },
                {
                    unit_id: "113301",
                    map: "45-3",
                },
                {
                    unit_id: "113601",
                    map: "46-3",
                },
                {
                    unit_id: "113701",
                    map: "47-3",
                },
                {
                    unit_id: "113801",
                    map: "48-3",
                },
                {
                    unit_id: "114001",
                    map: "49-3",
                },
                {
                    unit_id: "114201",
                    map: "50-3",
                },
                {
                    unit_id: "114301",
                    map: "51-3",
                },
                {
                    unit_id: "106401",
                    map: "52-3",
                },
                {
                    unit_id: "115701",
                    map: "53-3",
                },
                {
                    unit_id: "116001",
                    map: "54-3",
                },
                {
                    unit_id: "116301",
                    map: "55-3",
                },
                {
                    unit_id: "116501",
                    map: "56-3",
                },
            ],
            Megami: [
                { unit_id: "116601" },
                { unit_id: "116701" },
                { unit_id: "116901" },
                { unit_id: "117001" },
                { unit_id: "117101" },

                { unit_id: "117201" },
                { unit_id: "117301" },
                { unit_id: "117501" },
                { unit_id: "117601" },
                { unit_id: "117701" },

                { unit_id: "117901" },
                { unit_id: "119001" },
                { unit_id: "119901" },
                { unit_id: "119301" },
                { unit_id: "120701" },

                { unit_id: "120901" },
                { unit_id: "121001" },
                { unit_id: "116401" },
                { unit_id: "121101" },
                { unit_id: "121301" },

                { unit_id: "121401" },
                { unit_id: "121501" },
                { unit_id: "121601" },
                { unit_id: "180901" },
                { unit_id: "122001" },

                { unit_id: "121901" },
                { unit_id: "122201" },
                { unit_id: "122301" },
                { unit_id: "122501" },
                { unit_id: "122601" },

                { unit_id: "122901" },
                { unit_id: "122701" },
                { unit_id: "123101" },
                { unit_id: "123201" },
                { unit_id: "123301" },

                { unit_id: "123601" },
                { unit_id: "123701" },
                { unit_id: "123801" },
                { unit_id: "124101" },
                { unit_id: "124201" },

                { unit_id: "181001" },
                { unit_id: "124601" },
            ],
            Event: [
                { unit_id: "109801" },
                { unit_id: "112601" },
                { unit_id: "116801" },
                { unit_id: "117401" },
                { unit_id: "117801" },
                { unit_id: "119201" },
                { unit_id: "120801" },
                { unit_id: "121201" },
                { unit_id: "122101" },
                { unit_id: "122401" },
                { unit_id: "122801" },
                { unit_id: "123501" },
                { unit_id: "124101" },
                { unit_id: "124701" },
            ],
            MasterCoin: [
                { unit_id: "107101" },
                { unit_id: "106101" },
                { unit_id: "107501" },
                { unit_id: "107801" },
                { unit_id: "107701" },
                { unit_id: "107901" },
                { unit_id: "107001" },
                { unit_id: "108101" },
                { unit_id: "108301" },
                { unit_id: "108401" },
                { unit_id: "108601" },
                { unit_id: "108801" },
                { unit_id: "108701" },
                { unit_id: "180401" },
                { unit_id: "109101" },
                { unit_id: "180501" },
                { unit_id: "110001" },
                { unit_id: "110301" },
                { unit_id: "110401" },
                { unit_id: "110601" },
                { unit_id: "180201" },
                { unit_id: "106801" },
                { unit_id: "111101" },
                { unit_id: "109901" },
                { unit_id: "109701" },
                { unit_id: "111501" },
                { unit_id: "112001" },
                { unit_id: "111901" },
                { unit_id: "180101" },
                { unit_id: "180601" },
                { unit_id: "112401" },
                { unit_id: "112501" },
                { unit_id: "180301" },
                { unit_id: "113101" },
                { unit_id: "113401" },
                { unit_id: "180701" },
                { unit_id: "113901" },
                { unit_id: "118501" },
                { unit_id: "106701" },
                { unit_id: "114401" },
                { unit_id: "180801" },
                { unit_id: "111801" },
                { unit_id: "115001" },
                { unit_id: "115501" },
                { unit_id: "118101" },
                { unit_id: "180901" },
                { unit_id: "123001" },
                { unit_id: "118001" },
                { unit_id: "106901" },
            ],
            SubStory: [
                { unit_id: "103801" },
                { unit_id: "101201" },
                { unit_id: "100401" },
                { unit_id: "102001" },
                { unit_id: "101701" },

                { unit_id: "101001" },
                { unit_id: "107601" },
                { unit_id: "102801" },
                { unit_id: "108001" },
                { unit_id: "103201" },

                { unit_id: "104701" },
                { unit_id: "103401" },
                { unit_id: "108201" },
                { unit_id: "102201" },
                { unit_id: "100901" },

                { unit_id: "105101" },
                { unit_id: "108501" },
                { unit_id: "102901" },
                { unit_id: "108901" },
                { unit_id: "100201" },

                { unit_id: "109001" },
                { unit_id: "101101" },
                { unit_id: "104301" },
                { unit_id: "100801" },
                { unit_id: "109301" },

                { unit_id: "101801" },
                { unit_id: "105301" },
                { unit_id: "104501" },
                { unit_id: "110101" },
                { unit_id: "105001" },

                { unit_id: "110501" },
                { unit_id: "101401" },
                { unit_id: "104001" },
                { unit_id: "105601" },
                { unit_id: "111201" },

                { unit_id: "103601" },
                { unit_id: "103701" },
                { unit_id: "100501" },
                { unit_id: "111601" },
                { unit_id: "104401" },

                { unit_id: "112101" },
                { unit_id: "112301" },
                { unit_id: "110701" },
                { unit_id: "104601" },
                { unit_id: "103301" },

                { unit_id: "113001" },
                { unit_id: "106501" },
                { unit_id: "113201" },
                { unit_id: "102701" },
                { unit_id: "113501" },

                { unit_id: "102301" },
                { unit_id: "101601" },
                { unit_id: "101301" },
                { unit_id: "114101" },
                { unit_id: "105401" },

                { unit_id: "104801" },
                { unit_id: "114601" },
                { unit_id: "106001" },
                { unit_id: "114701" },
                { unit_id: "115601" },

                { unit_id: "100301" },
                { unit_id: "115801" },
            ],
            SubStoryList: [
                {
                    jp_event_name: "ハツネのプレゼント大作戦",
                    tw_event_name: "初音的禮物大作戰",
                    en_event_name: "ハツネのプレゼント大作戦",
                    event_id: "10001",
                    eventItemList: [{ unit_id: "103801" }, { unit_id: "101201" }],
                },
                {
                    jp_event_name: "リトルリリカルアドベンチャーズ",
                    tw_event_name: "小小甜心大冒險",
                    en_event_name: "リトルリリカルアドベンチャーズ",
                    event_id: "10002",
                    eventItemList: [{ unit_id: "100401" }, { unit_id: "102001" }],
                },
                {
                    jp_event_name: "ヴァンパイアハンターwithイリヤ",
                    tw_event_name: "吸血鬼獵人 with伊莉亞",
                    en_event_name: "ヴァンパイアハンターwithイリヤ",
                    event_id: "",
                    eventItemList: [{ unit_id: "101701" }, { unit_id: "101001" }],
                },
                {
                    jp_event_name: "デンジャラスバカンス",
                    tw_event_name: "危險的假期！海岸邊的美食家公主",
                    en_event_name: "デンジャラスバカンス",
                    event_id: "10004",
                    eventItemList: [{ unit_id: "107601" }, { unit_id: "102801" }],
                },
                {
                    jp_event_name: "無人島0ルピ生活",
                    tw_event_name: "珠希和美冬的無人島０盧幣生活",
                    en_event_name: "無人島0ルピ生活",
                    event_id: "10005",
                    eventItemList: [{ unit_id: "108001" }, { unit_id: "103201" }],
                },
                {
                    jp_event_name: "黒鉄のナイトメア",
                    tw_event_name: "黒鉄の亡霊",
                    en_event_name: "黒鉄のナイトメア",
                    event_id: "10006",
                    eventItemList: [{ unit_id: "104701" }, { unit_id: "103401" }],
                },
                {
                    jp_event_name: "トリックオアプリン",
                    tw_event_name: "不給布丁就搗蛋！約定的萬聖節派對",
                    en_event_name: "トリックオアプリン",
                    event_id: "10007",
                    eventItemList: [{ unit_id: "108201" }, { unit_id: "102201" }],
                },
                {
                    jp_event_name: "トワイライトブレイカーズ",
                    tw_event_name: "暮光破壞者",
                    en_event_name: "トワイライトブレイカーズ",
                    event_id: "10008",
                    eventItemList: [{ unit_id: "100901" }, { unit_id: "105101" }],
                },
                {
                    jp_event_name: "忘却のキャロル",
                    tw_event_name: "忘却的頌歌",
                    en_event_name: "忘却のキャロル",
                    event_id: "10009",
                    eventItemList: [{ unit_id: "108501" }, { unit_id: "102901" }],
                },
                {
                    jp_event_name: "新春トゥインクルクライシス",
                    tw_event_name: "新春破曉之星大危機！",
                    en_event_name: "新春トゥインクルクライシス",
                    event_id: "10010",
                    eventItemList: [{ unit_id: "108901" }, { unit_id: "100201" }],
                },
                {
                    jp_event_name: "バトルオブバレンタイン",
                    tw_event_name: "情人節之戰！ 正中紅心的甜蜜戰鬥",
                    en_event_name: "バトルオブバレンタイン",
                    event_id: "10011",
                    eventItemList: [{ unit_id: "109001" }, { unit_id: "101101" }],
                },
                {
                    jp_event_name: "嘆きのストーカー",
                    tw_event_name: "王都的名偵探　嘆息的追緝者",
                    en_event_name: "嘆きのストーカー",
                    event_id: "10012",
                    eventItemList: [{ unit_id: "104301" }, { unit_id: "100801" }],
                },
                {
                    jp_event_name: "アストルムに咲く双輪の華",
                    tw_event_name: "在阿斯特朗盛開的雙輪之花",
                    en_event_name: "アストルムに咲く双輪の華",
                    event_id: "10013",
                    eventItemList: [{ unit_id: "109301" }, { unit_id: "101801" }],
                },
                {
                    jp_event_name: "ショーグン道中記",
                    tw_event_name: "將軍道中記　白翼的武士",
                    en_event_name: "ショーグン道中記",
                    event_id: "10015",
                    eventItemList: [{ unit_id: "105301" }, { unit_id: "104501" }],
                },

                {
                    jp_event_name: "スズナレインボーステージ",
                    tw_event_name: "鈴奈的彩虹舞臺！",
                    en_event_name: "スズナレインボーステージ",
                    event_id: "10019",
                    eventItemList: [{ unit_id: "110101" }, { unit_id: "105001" }],
                },
                {
                    jp_event_name: "真夏のマホマホ王国",
                    tw_event_name: "盛夏的真步真步王國 浪花拍岸的靈魂之夏！",
                    en_event_name: "真夏のマホマホ王国",
                    event_id: "10021",
                    eventItemList: [{ unit_id: "110501" }, { unit_id: "101401" }],
                },
                {
                    jp_event_name: "森の臆病者と聖なる学舎の異端児",
                    tw_event_name: "森林的膽小鬼與神聖學院的問題兒童",
                    en_event_name: "森の臆病者と聖なる学舎の異端児",
                    event_id: "10023",
                    eventItemList: [{ unit_id: "104001" }, { unit_id: "105601" }],
                },
                {
                    jp_event_name: "リトルブレイブハロウィンナイト",
                    tw_event_name: "小小勇敢的萬聖節之夜！",
                    en_event_name: "リトルブレイブハロウィンナイト",
                    event_id: "10025",
                    eventItemList: [{ unit_id: "111201" }, { unit_id: "103601" }],
                },
                {
                    jp_event_name: "ドラゴンエクスプローラーズ",
                    tw_event_name: "龍的探索者們",
                    en_event_name: "ドラゴンエクスプローラーズ",
                    event_id: "10027",
                    eventItemList: [{ unit_id: "103701" }, { unit_id: "100501" }],
                },
                {
                    jp_event_name: "プレゼントパニック",
                    tw_event_name: "禮物大恐慌！蘭德索爾的聖誕老人們",
                    en_event_name: "プレゼントパニック",
                    event_id: "",
                    eventItemList: [{ unit_id: "111601" }, { unit_id: "104401" }],
                },
                {
                    jp_event_name: "ランドソルギルドレース",
                    tw_event_name: "狂奔！　蘭德索爾的公會競速賽",
                    en_event_name: "ランドソルギルドレース",
                    event_id: "",
                    eventItemList: [{ unit_id: "112101" }, { unit_id: "102101" }],
                },
                {
                    jp_event_name: "魔法少女ミスティ&ピュアリー",
                    tw_event_name: "魔法少女　兩人是Misty&Purely",
                    en_event_name: "魔法少女ミスティ&ピュアリー",
                    event_id: "",
                    eventItemList: [{ unit_id: "112301" }, { unit_id: "104901" }],
                },
                {
                    jp_event_name: "授けの財団と聖なる学舎の異端児",
                    tw_event_name: "恩賜的財團與神聖學院的問題兒童",
                    en_event_name: "授けの財団と聖なる学舎の異端児",
                    event_id: "",
                    eventItemList: [{ unit_id: "110701" }, { unit_id: "104601" }],
                },
                {
                    jp_event_name: "まきばの四農士",
                    tw_event_name: "牧場的四農士",
                    en_event_name: "まきばの四農士",
                    event_id: "10067",
                    eventItemList: [{ unit_id: "103301" }, { unit_id: "102801" }],
                },
                {
                    jp_event_name: "不思議の国のリノ",
                    tw_event_name: "不可思議之國的璃乃",
                    en_event_name: "不思議の国のリノ",
                    event_id: "",
                    eventItemList: [{ unit_id: "113001" }, { unit_id: "106501" }],
                },
                {
                    jp_event_name: "天に流れる夏の恋",
                    tw_event_name: "天際川流夏之戀",
                    en_event_name: "天に流れる夏の恋",
                    event_id: "10044",
                    eventItemList: [{ unit_id: "113201" }, { unit_id: "102701" }],
                },
                {
                    jp_event_name: "ミサトサマーエール",
                    tw_event_name: "美里的夏日聲援！　追夢的盛夏棒球隊",
                    en_event_name: "ミサトサマーエール",
                    event_id: "",
                    eventItemList: [{ unit_id: "113501" }, { unit_id: "102301" }],
                },
                {
                    jp_event_name: "ハッピーチェンジエンジェルズ",
                    tw_event_name: "Happy・Change・Angels",
                    en_event_name: "ハッピーチェンジエンジェルズ",
                    event_id: "10048",
                    eventItemList: [{ unit_id: "101601" }, { unit_id: "101301" }],
                },
                {
                    jp_event_name: "ハロウィンゴーストフェスティバル",
                    tw_event_name: "迴響！尖叫！萬聖鬼怪狂歡節",
                    en_event_name: "ハロウィンゴーストフェスティバル",
                    event_id: "10050",
                    eventItemList: [{ unit_id: "114101" }, { unit_id: "105401" }],
                },
                {
                    jp_event_name: "魔法提督ラブリーモニカ",
                    tw_event_name: "魔法提督Lovely★莫妮卡　Let's Go！魔法的四重奏！",
                    en_event_name: "魔法提督ラブリーモニカ",
                    event_id: "",
                    eventItemList: [{ unit_id: "103701" }, { unit_id: "101401" }],
                },
                {
                    jp_event_name: "新春グルメプリンセス！",
                    tw_event_name: "新春美食公主！　賭上關鍵一擲的少女們",
                    en_event_name: "新春グルメプリンセス！",
                    event_id: "10056",
                    eventItemList: [{ unit_id: "106001" }, { unit_id: "114701" }],
                },
                {
                    jp_event_name: "デビュタントシャングリラ",
                    tw_event_name: "名媛初登夢想秘境　聖誕夜的戀愛遊戲",
                    en_event_name: "デビュタントシャングリラ",
                    event_id: "10054",
                    eventItemList: [{ unit_id: "104801" }, { unit_id: "114601" }],
                },
                {
                    jp_event_name: "絆、つないで。こころ、結んで。",
                    tw_event_name: "羈絆相連。心相繫。",
                    en_event_name: "絆、つないで。こころ、結んで。",
                    event_id: "10058",
                    eventItemList: [{ unit_id: "115601" }, { unit_id: "100301" }],
                },
                {
                    jp_event_name: "シンデレラレッスン",
                    tw_event_name: "灰姑娘課程　璀璨的日子有著蘋果的滋味",
                    en_event_name: "シンデレラレッスン",
                    event_id: "10061",
                    eventItemList: [{ unit_id: "115801" }, { unit_id: "101001" }],
                },
                {
                    jp_event_name: "鋼の聖女と聖なる学舎の異端児",
                    tw_event_name: "鋼鐵聖女與神聖學院的問題兒童",
                    en_event_name: "鋼の聖女と聖なる学舎の異端児",
                    event_id: "10064",
                    eventItemList: [{ unit_id: "103201" }, { unit_id: "103101" }],
                },
                {
                    jp_event_name: "タイムトラベルドラゴンズ",
                    tw_event_name: "祈梨ＳＯＳ！！ 踏上時空旅行的龍人族",
                    en_event_name: "タイムトラベルドラゴンズ",
                    event_id: "10066",
                    eventItemList: [{ unit_id: "106501" }, { unit_id: "101501" }],
                },
                {
                    jp_event_name: "アオイトイフレンズ",
                    tw_event_name: "心電感應！碧與玩具朋友們",
                    en_event_name: "アオイトイフレンズ",
                    event_id: "10068",
                    eventItemList: [{ unit_id: "116801" }, { unit_id: "104001" }],
                },
            ],
        };
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "角色碎片取得一覽",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
    },
    methods: {
        getI18nName: function(item, name) {
            switch (this.locale) {
                case "en":
                    return item["en_" + name];
                    break;
                case "jp":
                    return item["jp_" + name];
                    break;
                case "tw":
                    return item["tw_" + name];
                    break;
                default:
                    return item[name];
                    break;
            }
        },
        getItemName: function(unit) {
            return Number(unit.substring(0, 4)) + 30000;
        },
        getUnitName: function(unit) {
            var self = this;
            var data = _.find(self.$store.getters.getUnitData, ["unit_id", unit.unit_id.toString()]);
            if (!data) {
                return;
            }
            return this.getI18nName(data, "unit_name");
        },
    },
    created: function() {},
    computed: {
        locale() {
            return this.$i18n.locale;
        },
    },
    mounted: function() {},
};
</script>
